module.exports = __webpack_public_path__ + "static/jerald-francis-9037c70ebb3a6a32b9ec6863605f75de.png";